import { TTask } from "../types/generalTypes";
import { TPartMode } from "../types/unitTypes";

export type TContentLabel = {
  [key in TTask]: string;
};

export const contentLabels: TContentLabel = {
  PRACTICE: "Antrenman",
  PROJECT: "Proje",
  UNIT: "Ders",
  LIVE_EVENT: "Canlı",
};

export const contentPaths: TContentLabel = {
  PRACTICE: "practice",
  PROJECT: "proje",
  UNIT: "ders",
  LIVE_EVENT: "",
};

export const partModeLabels: Record<TPartMode, string> = {
  VIDEO: "Anlatım",
  PRACTICE: "Uygulama",
  ZOOM: "Canlı değerlendirme",
};

export const lsUserKey = "kaizu_";

export const DEMO_COHORT_IDS = [331, 332];
